import { Link } from "react-router-dom";
import { Container, PillButton } from "@/components/common/ui";

export default function NotFoundPage() {
  return (
    <Container className="py-32 text-center" >
      <p className="eyebrow">404</p>
      <h1 className="mt-4 font-display text-5xl" data-testid="not-found-title">Off course.</h1>
      <p className="mt-3 text-neutral-600">That page doesn't exist. Let's get you back on track.</p>
      <div className="mt-8 flex justify-center gap-3">
        <PillButton to="/" testId="not-found-home">Home</PillButton>
        <Link to="/search" className="inline-flex h-11 items-center rounded-full border border-ink px-6" data-testid="not-found-search">Search homes</Link>
      </div>
    </Container>
  );
}
